import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';
import { Termination , UpdateTermination ,deleteTermination , FetchTerminationById   } from './terminationType';

export const createTermination = createAsyncThunk(
    'termination/createTermination',
    async (data: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/termination', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create termination');
      }
    }
  ); 

  export const Updatetermination = createAsyncThunk<any , {terminationId: number; data: any}, { rejectValue: string }>(
    'termination/updateTermination',
    async ({terminationId , data}: {terminationId : Number; data: Partial<UpdateTermination>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/termination/${terminationId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create termination');
      }
    }
  ); 


  export const deletetermination = createAsyncThunk(
    'termination/delete',
    async (TerminationId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/termination/${TerminationId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete termination');
        }
    }
);

export const fetchTerminationById = createAsyncThunk(
    'termination/fetchById',
    async (TerminationId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/termination/${TerminationId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Termination');
        }
    }
);

export const fetchAllTermination = createAsyncThunk(
    'termination/fetchAlltermination',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/termination');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Termination');
        }
    }
);